const actions = {
  SET_STATE: 'school/SET_STATE',
  SOME_FUNCTION: 'studnet/SOME_FUNCTION',
  SCHOOL_DETAILS: 'school/SCHOOL_DETAILS',
  UPDATE_ML: 'school/UPDATE_ML',
}

export default actions
